import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';


@Injectable()
export class SessionProvider {

    constructor() { }

    clear() {
        var uniqid = localStorage.getItem("UniqId");
        localStorage.clear();
        localStorage.setItem('UniqId', uniqid.toString());
    }
    SetUp(username , password) {
        localStorage.setItem('lu', username);
        localStorage.setItem('lp', password);
    }
    getUp() {
        return {
            username: localStorage.getItem('lu'),
            password: localStorage.getItem('lp')
        };
        
    }
    setMember(value) {
        localStorage.setItem('AuthMember', JSON.stringify(value));
        localStorage.setItem('AuthMemberToken', value.Token);
        localStorage.setItem('AuthMemberRoleId', value.tRoleId)
        localStorage.setItem('AuthMemberFullName', value.Name);
        localStorage.setItem('AuthMemberUsername', value.Username);
    }
    getUniqId() {
        if (localStorage.getItem("UniqId") != null) {
            return localStorage.getItem("UniqId");
        }
        var min = 10000000000;
        var max = 99999999999;
        let random =
            Math.floor(Math.random() * (+max - +min)) + +min;
        localStorage.setItem('UniqId', random.toString());
        return random.toString();
    }
    getMember() { return JSON.parse(localStorage.getItem('AuthMember')); }
    getToken() { return localStorage.getItem('AuthMemberToken'); }
    getRole() { return localStorage.getItem('AuthMemberRoleId'); }
    getFullname() { return localStorage.getItem('AuthMemberFullName'); }
    getUsername() { return localStorage.getItem('AuthMemberUsername'); }

    setMemberBook_CurrentMemberBookId(value) { localStorage.setItem('MemberBook_CurrentMemberBookId', value); }
    getMemberBook_CurrentMemberBookId() { return localStorage.getItem('MemberBook_CurrentMemberBookId'); }

    setMemberBook_CurrentMemberBookPageId(value) { localStorage.setItem('MemberBook_CurrentMemberBookPageId', value); }
    getMemberBook_CurrentMemberBookPageId() { return localStorage.getItem('MemberBook_CurrentMemberBookPageId'); }

    setMemberBook_CurrentMemberBookQuizId(value) { localStorage.setItem('MemberBook_CurrentMemberBookQuizId', value); }
    getMemberBook_CurrentMemberBookQuizId() { return localStorage.getItem('MemberBook_CurrentMemberBookQuizId'); }


    
}



// WEBPACK FOOTER //
// ./src/providers/SessionProvider.ts